function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { isObjectEmpty } from "./core";
export function getPath(obj, path) {
  var result = obj;
  var keys = path.split(".");

  for (var i = 0; i < keys.length; i++) {
    result = result[keys[i]];

    if (typeof result === "undefined") {
      return;
    }
  }

  return result;
}
export function setPath(obj, path, value) {
  var keys = path.split(".");
  var result = value;

  for (var i = keys.length - 1; i > 0; i--) {
    var subPath = keys.slice(0, i).join(".");

    var _value = getPath(obj, subPath);

    var valueType = _typeof(_value);

    if (valueType !== "object" && valueType !== "undefined") {
      throw new Error("Values along the path \"".concat(path, "\" must be objects. Found \"").concat(valueType, "\" at path \"").concat(subPath, "\"."));
    }

    result = _objectSpread(_objectSpread({}, _value), {}, _defineProperty({}, keys[i], result));
  }

  return _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, keys[0], result));
}
export function deletePath(obj, path) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$deleteEmptyObjec = _ref.deleteEmptyObjects,
      deleteEmptyObjects = _ref$deleteEmptyObjec === void 0 ? false : _ref$deleteEmptyObjec;

  var keys = path.split(".");
  var pathsArr = [obj];
  var subPath = "";
  var value = obj;

  for (var i = 0; i < keys.length - 1; i++) {
    var key = keys[i];
    subPath = "".concat(subPath).concat(i === 0 ? "" : ".").concat(key);
    value = value[key];

    if (_typeof(value) !== "object") {
      return obj;
    }

    pathsArr.push(value);
  }

  var result = _objectSpread({}, pathsArr[pathsArr.length - 1]);

  delete result[keys[keys.length - 1]];

  for (var _i = pathsArr.length - 2; _i >= 0; _i--) {
    var _key = keys[_i];
    var shouldDeleteKey = deleteEmptyObjects === true || Array.isArray(deleteEmptyObjects) && deleteEmptyObjects.includes(_key) === false;

    if (shouldDeleteKey && isObjectEmpty(result)) {
      result = _objectSpread({}, pathsArr[_i]);
      delete result[_key];
    } else {
      result = _objectSpread(_objectSpread({}, pathsArr[_i]), {}, _defineProperty({}, _key, result));
    }
  }

  return result;
}